import styles from "./page.module.css";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import DashboardSection from "./dashboard/dashboardSection";
import DashboardTimetable from "./dashboard/dashboardTimeTable";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import BookingManagement from "./BookingManagement/BookingManagement";
import ProfileManagement from "./profiles/ProfileManagement";
import { useEffect, useState } from "react";
import LogedinHeaderComponent from "components/logedinHeaderComponent/logedinHeaderComponent";
import { useNavigate } from "react-router-dom";
import { checkSession } from "services/userLogin/check-session";

export default function CustomerPage() {
  const sections = [
    { id: "overview", label: "Übersicht" },
    { id: "bookingManage", label: "Buchungsverwaltung" },
    { id: "Profil", label: "Profil" },
  ];

  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState<string>(sections[0].id);
  const [activeTab, setActiveTab] = useState<string>("overview");

  const handleSectionClick = (tabId: string) => {
    if (tabId !== activeSection) {
      setActiveSection(tabId);
      window.history.pushState({ tabId }, "", `#${tabId}`); 
    }
  };

  const handleBookingDetailsClick = () => {
    setActiveSection("bookingManage");
    setActiveTab("bookings");
    window.history.pushState({ tabId: "bookingManage", tab: "bookings" }, "", "#bookingManage"); 
  };

  const handleCancellationDetailsClick = () => {
    setActiveSection("bookingManage");
    setActiveTab("cancellations");
    window.history.pushState({ tabId: "bookingManage", tab: "cancellations" }, "", "#bookingManage"); 
  };

  const verifySession = async () => {
    try {
      const sessionData = await checkSession();
      if (sessionData.session_active) {
        const { is_customer, is_employee, is_profile_completed, is_password_completed, is_statistic } = sessionData.user_data;
        if (!is_customer) {
          if (is_employee) {
            if (is_password_completed) {
              if(is_statistic){
                navigate('/reservierungsportal/StatisticPage', { replace: true });

              }else{
                navigate('/reservierungsportal/EmployHomePage', { replace: true });
              }
            } else {
              
              navigate('/reservierungsportal/EmploySetPassword', { replace: true });
            }
          } else {
            navigate('/reservierungsportal');
          }
        } else {
          if (!is_profile_completed) {
            navigate("/reservierungsportal/compliatProfile", { replace: true });
          } else {
            navigate("/reservierungsportal/CustomerHomePage", { replace: true });
          }
        }
      } else {
        navigate('/reservierungsportal', { replace: true });
      }
    } catch (error) {
      console.error("Fehler bei der Sitzungsprüfung:", error);
    }
  };

  useEffect(() => {
    verifySession();
  }, []);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      const { tabId, tab } = event.state || { tabId: sections[0].id, tab: "overview" };
      setActiveSection(tabId);
      setActiveTab(tab);
    };

    window.addEventListener("popstate", handlePopState);

    const initialTabId = window.location.hash.substring(1) || sections[0].id;
    setActiveSection(initialTabId);
 
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [sections]);

  return (
    <div className={styles.page}>
      <Header>
        <LogedinHeaderComponent sections={sections} activeSection={activeSection} onTabChange={handleSectionClick} isWithSearch={false} />
      </Header>
      <main className={styles.main}>
        {activeSection === "overview" && <section className={commonStyles.sectionContainer}>
          <DashboardSection
            onBookingDetailsClick={handleBookingDetailsClick}
            onCancellationDetailsClick={handleCancellationDetailsClick} />
          <DashboardTimetable />
        </section>}
        {activeSection === "bookingManage" && <section className={commonStyles.sectionContainer} >
          <BookingManagement activeTab={activeTab} onTabClick={setActiveTab} />
        </section>}
        {activeSection === "Profil" && <section className={commonStyles.sectionContainer} >
          <ProfileManagement />
        </section>}
      </main>
      <Footer />
    </div>
  );
}
